module.exports = __webpack_public_path__ + "static/media/shop-website.9918614a.png";